/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import type SemeiaSessionService from "parog-web/services/session";

import styles from "./index.module.css";

interface Signature {
  Args: {
    onValueUpdated?: unknown;
    inputValue?: unknown;
    currentOperator?: unknown;
    propertyName?: unknown;
    onOperatorUpdated: (value: string) => void;
  };
}

export default class BioExamResultsInputWithOperator extends Component<Signature> {
  styles = styles;

  @service declare session: SemeiaSessionService;

  @action
  onChange(value) {
    let cleanedValue;
    switch (value) {
      case "&lt;":
        cleanedValue = "lower-than";
        break;
      case "&gt;":
        cleanedValue = "greater-than";
        break;
      default:
        cleanedValue = "equal-to";
        break;
    }

    this.args.onOperatorUpdated(cleanedValue);
  }

  get disabled() {
    if (!this.session.medic) return true;

    return !this.session.medic.isSuperUser;
  }
}
